// Regles de numerotation par pays pour l'inscription (numero NATIONAL, sans indicatif ni zero initial).
// Copie jumelle dans frontend/src/data/phoneRules.js : garder les deux fichiers identiques.
// strip0 : le zero « de ligne » que l'on tape en local (06 12 34 56 78 en France) n'est pas dans le numero
// international WhatsApp : on le retire avant de verifier et d'enregistrer.
const RULES = {
  '+237': { re: /^6\d{8}$/, example: '6XX XX XX XX', hint: '9 chiffres, commence par 6' },
  '+225': { re: /^\d{10}$/, example: '07 XX XX XX XX', hint: '10 chiffres' },
  '+221': { re: /^7\d{8}$/, example: '7X XXX XX XX', hint: '9 chiffres, commence par 7' },
  '+241': { re: /^\d{7,9}$/, strip0: true, example: '6X XX XX XX', hint: '7 à 9 chiffres' },
  '+242': { re: /^\d{8,9}$/, strip0: true, example: '06 XXX XXXX', hint: '8 ou 9 chiffres' },
  '+243': { re: /^[1-9]\d{8}$/, strip0: true, example: '8X XXX XXXX', hint: '9 chiffres' },
  '+234': { re: /^[789]\d{9}$/, strip0: true, example: '80X XXX XXXX', hint: '10 chiffres, commence par 7, 8 ou 9' },
  '+27': { re: /^[1-9]\d{8}$/, strip0: true, example: '8X XXX XXXX', hint: '9 chiffres' },
  '+212': { re: /^[5-7]\d{8}$/, strip0: true, example: '6XX XX XX XX', hint: '9 chiffres, commence par 5, 6 ou 7' },
  '+216': { re: /^[2-9]\d{7}$/, example: '2X XXX XXX', hint: '8 chiffres' },
  '+213': { re: /^[5-7]\d{8}$/, strip0: true, example: '5XX XX XX XX', hint: '9 chiffres, commence par 5, 6 ou 7' },
  '+33': { re: /^[1-9]\d{8}$/, strip0: true, example: '6 XX XX XX XX', hint: '9 chiffres (sans le 0 initial)' },
  '+32': { re: /^4\d{8}$/, strip0: true, example: '4XX XX XX XX', hint: '9 chiffres, commence par 4' },
  '+41': { re: /^7\d{8}$/, strip0: true, example: '7X XXX XX XX', hint: '9 chiffres, commence par 7' },
  '+44': { re: /^7\d{9}$/, strip0: true, example: '7XXX XXXXXX', hint: '10 chiffres, commence par 7' },
  '+49': { re: /^1\d{9,10}$/, strip0: true, example: '15X XXXXXXXX', hint: '10 ou 11 chiffres, commence par 1' },
  '+39': { re: /^3\d{8,9}$/, example: '3XX XXX XXXX', hint: '9 ou 10 chiffres, commence par 3' },
  '+34': { re: /^[67]\d{8}$/, example: '6XX XXX XXX', hint: '9 chiffres, commence par 6 ou 7' },
  '+1': { re: /^[2-9]\d{9}$/, example: '(XXX) XXX-XXXX', hint: '10 chiffres' },
  '+509': { re: /^[2-5]\d{7}$/, example: '3X XX XXXX', hint: '8 chiffres' },
  '+596': { re: /^\d{9}$/, strip0: true, example: '696 XX XX XX', hint: '9 chiffres (sans le 0 initial)' },
  '+590': { re: /^\d{9}$/, strip0: true, example: '690 XX XX XX', hint: '9 chiffres (sans le 0 initial)' },
  '+971': { re: /^5\d{8}$/, strip0: true, example: '5X XXX XXXX', hint: '9 chiffres, commence par 5' },
  '+966': { re: /^5\d{8}$/, strip0: true, example: '5X XXX XXXX', hint: '9 chiffres, commence par 5' },
};
const DEFAULT_RULE = { re: /^\d{7,15}$/, example: '', hint: '7 à 15 chiffres' };

// Retire espaces, points, tirets, parentheses et le zero initial des pays concernes.
function normalizePhone(countryCode, raw) {
  let digits = String(raw || '').replace(/[\s.\-()]/g, '');
  const rule = RULES[countryCode];
  if (rule && rule.strip0) digits = digits.replace(/^0+/, '');
  return digits;
}

// -> { ok: true, digits } ou { ok: false, message }
function checkPhone(countryCode, raw) {
  const digits = normalizePhone(countryCode, raw);
  const rule = RULES[countryCode] || DEFAULT_RULE;
  if (!/^\d+$/.test(digits)) return { ok: false, message: 'Le numéro ne doit contenir que des chiffres (sans le code pays).' };
  if (!rule.re.test(digits)) {
    const e = rule.example ? ` Exemple : ${rule.example}.` : '';
    return { ok: false, message: `Numéro invalide pour ce pays (${rule.hint}).${e}` };
  }
  return { ok: true, digits };
}

export { RULES, normalizePhone, checkPhone };
